export default "__VITE_ASSET__SjK$v$7c__"